var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Status',{attrs:{"value":_vm.connected,"ok-label":_vm.$t('connected'),"ko-label":_vm.$t('disconnected')}})
}
var staticRenderFns = []

export { render, staticRenderFns }